import { ArrowDown, MoveUpRight } from 'lucide-react';
import { Reveal, Eyebrow, AnimatedHeading, ActionLink, Stats, CTABand } from '../components/Shared';
import { OrbitalScene } from '../components/OrbitalScene';
import { TrustStrip, ServiceGrid, ValueBand, TechEcosystem, GlobalOffices } from '../components/HomeSections';
import { ImpactMetrics } from '../components/ImpactMetrics';
import { Testimonials } from '../components/Testimonials';
import { L } from '../i18n/LocaleProvider';
import { metricsConfig, statItems } from '../data/metrics';
import { company } from '../data/content';
import { useSeo } from '../hooks/useSeo';
import { ProofStrip } from '../components/ProofStrip';
import { GeoSections, GeoFaq, entityStatement, faqs } from '../components/GeoSections';
import { services } from '../data/content';

const ORIGIN = 'https://www.techspitze.com';
const homeJsonLd = [
  {
    '@context': 'https://schema.org', '@type': 'Organization', name: 'TechSpitze', url: ORIGIN,
    logo: `${ORIGIN}/brand/techspitze-logo.webp`, description: entityStatement,
    sameAs: ['https://www.linkedin.com/company/techspitze/'],
    address: { '@type': 'PostalAddress', addressCountry: 'CA' },
    contactPoint: [{ '@type': 'ContactPoint', contactType: 'sales', url: `${ORIGIN}/contact`, areaServed: 'CA', availableLanguage: ['en', 'fr', 'es'] }],
  },
  { '@context': 'https://schema.org', '@type': 'WebSite', name: 'TechSpitze', url: ORIGIN, inLanguage: 'en-CA' },
  {
    '@context': 'https://schema.org', '@type': 'ProfessionalService', name: 'TechSpitze', url: ORIGIN,
    description: entityStatement, areaServed: { '@type': 'Country', name: 'Canada' },
    address: { '@type': 'PostalAddress', addressCountry: 'CA' },
    serviceType: ['AI Automation', 'Digital Transformation', 'Enterprise Technology', 'Software & Digital Products', 'Digital Growth'],
    hasOfferCatalog: {
      '@type': 'OfferCatalog', name: 'TechSpitze services',
      itemListElement: services.map(service => ({ '@type': 'Offer', itemOffered: { '@type': 'Service', name: service.name, description: service.description } })),
    },
  },
  {
    '@context': 'https://schema.org', '@type': 'FAQPage',
    mainEntity: faqs.map(item => ({ '@type': 'Question', name: item.q, acceptedAnswer: { '@type': 'Answer', text: item.a } })),
  },
];

export default function Home() {
  useSeo({
    title: 'TechSpitze | AI Automation & Digital Transformation – Canada',
    description: 'Canadian IT consulting for AI automation, digital transformation and enterprise technology — for growing businesses, enterprises and the public sector.',
    image: '/brand/techspitze-share.png',
    jsonLd: homeJsonLd,
  });
  return <L><main id="main-content" data-testid="home-page">
    <section className="container hero">
      <div className="hero-copy">
        <Reveal><Eyebrow id="home-hero-eyebrow" dot>IT SOLUTIONS & CONSULTING</Eyebrow></Reveal>
        <AnimatedHeading id="home-hero-heading" lines={[{ text: 'Lead the future' }, { text: 'of your' }, { text: 'industry.', accent: true }]} />
        <Reveal delay={.35}><p className="hero-description" data-testid="home-hero-description">{company.heroSupportLine}</p><div className="hero-actions"><ActionLink id="hero-get-started">Get Started</ActionLink><ActionLink to="/services" secondary id="hero-explore-services" arrow="right">Explore Services</ActionLink></div></Reveal>
        <Reveal delay={.5}><Stats id="home-stats" items={statItems(metricsConfig.heroKeys)} /></Reveal>
      </div>
      <OrbitalScene />
      <div className="hero-bottom" aria-hidden="true"><span><ArrowDown size={13} /> SCROLL TO EXPLORE</span><span>BRINGING INNOVATION TOGETHER <MoveUpRight size={13} /></span></div>
    </section>
    <ProofStrip /><TrustStrip /><GeoSections /><ServiceGrid /><ValueBand /><ImpactMetrics /><TechEcosystem /><Testimonials /><GlobalOffices /><CTABand id="home-cta" title={<>Your next chapter.<br />Let’s build it.</>} /><GeoFaq />
  </main></L>;
}